export type AppModeType = "APP" | "ASSESSMENT";

export const APP_MODE: AppModeType = (import.meta.env?.VITE_APP ?? "APP") as AppModeType;
export const API_URL = import.meta.env?.VITE_API_URL;
export const DOMAIN = import.meta.env?.VITE_DOMAIN;
export const SP_URL = import.meta.env?.VITE_SP_URL;
